import { AuthConfig } from "@auth0/auth0-angular";
import { AuthCacheService } from "@rr/shared-data-access-core";
import { UtilUrlHelper } from "@rr/shared-util";
const cId = "2ST2oHW9GgpZ6gComl0VGxbPXgnigCCR";
const tenant = UtilUrlHelper.getTenantFromUrl();
const subDomain = tenant ? `${tenant}.` : "";
const appUrl = `https://${subDomain}forms-staging.agridence.com`;

export const environment = {
  name: "staging",
  production: false,
  auth0: {
    domain: "https://id-staging.agridence.com",
    clientId: cId,
    authorizationParams: {
      redirect_uri: `${appUrl}/auth/callback`,
      audience: "https://forms.agridence.com",
      organization: tenant ?? "",
      scope: "openid profile email offline_access",
    },
    cache: new AuthCacheService(),
    useRefreshTokens: true,
    errorPath: `${appUrl}/error`,
  } as AuthConfig,
  appUrl: appUrl,
  firebase: {
    apiKey: "AIzaSyAHFDbqRHQIOeMr9I8WR2n_BAbwhLGtZdo",
    authDomain: "hcplatform-staging.firebaseapp.com",
    projectId: "hcplatform-staging",
    storageBucket: "agd-forms-assets-staging",
    messagingSenderId: "800225234444",
    appId: "1:800225234444:web:619cc74259c23e42eaa829",
    measurementId: "G-R4LS895FN4",
  },
  apiUrl: "https://api-forms-staging.agridence.com",
  themeUrl: "https://assets.agridence.com/configs/staging/{tenant}/config.json",
  postHog: {
    key: "phc_fm5mN5KojyVEE02jTAUx4KN4w0Seip0LNJFsrrgHgZA",
    host: "https://us.i.posthog.com",
  },
  sentry: {
    dsn: "https://61532cee75549c1acb92e2f457b88183@o4510859648892928.ingest.de.sentry.io/4510985201975376",
    debug: false,
  },
};
